import { TemplateRef, ViewContainerRef } from '@angular/core';
import { CurrentUserService, UserRoles } from '../services/current-user.service';
var AllowedRoleDirective = /** @class */ (function () {
    function AllowedRoleDirective(templateRef, viewContainer, currentUserService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.currentUserService = currentUserService;
    }
    Object.defineProperty(AllowedRoleDirective.prototype, "appEnableForRoles", {
        set: function (allowedRoles) {
            this.allowedRoles = allowedRoles;
        },
        enumerable: true,
        configurable: true
    });
    AllowedRoleDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.currentUserService.get()
            .subscribe(function (user) {
            if (user.roles & _this.allowedRoles) {
                _this.viewContainer.createEmbeddedView(_this.templateRef);
            }
            else {
                _this.viewContainer.clear();
            }
        });
    };
    return AllowedRoleDirective;
}());
export { AllowedRoleDirective };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/directives/allowed-role.directive.ts.pre-build-optimizer.js